import { Cookie } from './cookie';

export function getAtlCohortId(allCookies?: string): number | undefined {
	let atlCohortId: string | undefined;
	try {
		const atlCohort = Cookie.readCookie('atlCohort', allCookies);
		atlCohortId = JSON.parse(atlCohort || '')?.bucketAll?.index;
		if (!atlCohortId) {
			return undefined;
		}

		const atlCohortInit = parseInt(atlCohortId);
		if (isNaN(atlCohortInit) || atlCohortInit < 0) {
			return undefined;
		}

		return atlCohortInit;
	} catch (error) {
		return undefined;
	}
}
